import fetch from '../utils/fetch'

export function getCardList (query) {
  return fetch({
    url: '/discountcard/list',
    method: 'get',
    params: query
  })
}

export function getCardListnoAuth (query) {
    return fetch({
        url: '/discountcard/list/noAuth',
        method: 'get',
        params: query
    })
}

export function updateCardSort(query) {
   return fetch({
       url:'/discountcard/upsort',
       method:'put',
       params:query
   })
}

export function getEffectiveCardList (query) {
  return fetch({
    url: '/effectiveDiscountcard/list',
    method: 'get',
    params: query
  })
}

export function getCardUserList (query) {
  return fetch({
    url: '/discountcard/detail/list',
    method: 'get',
    params: query
  })
}
export function delUserCard (query) {
  return fetch({
    url: '/discountcard/detail/del',
    method: 'delete',
    params: query
  })
}
export function exportCardUsed(query) {
    return fetch({
        url: '/discountcard/detail/list/exportdata',
        method: 'get',
        params: query,
    })
}
export function getCardDetail (query) {
  return fetch({
    url: '/discountcard/get',
    method: 'get',
    params: query
  })
}

export function creatCard (query) {
  return fetch({
    url: '/discountcard',
    method: 'post',
    data: query
  })
}

export function updateCard (query) {
  return fetch({
    url: '/save_discountcard',
    method: 'post',
    data: query
  })
}

export function removeCard (query) {
  return fetch({
    url: '/discountcard',
    method: 'delete',
    params: query
  })
}

export function getWechatColor () {
  return fetch({
    url: '/card/color',
    method: 'get'
  })
}

export function getCouponHtml (cardId) {
  return fetch({
    url: '/card/html',
    method: 'get',
    params: cardId
  })
}

export function getQRcode (cardId) {
  return fetch({
    url: '/card/qrcode/' + cardId,
    method: 'get'
  })
}

export function pullWechatCard () {
  return fetch({
    url: '/card/sync',
    method: 'get'
  })
}

export function updateStore (query) {
  return fetch({
    url: '/discountcard/updatestore',
    method: 'post',
    data: query
  })
}
//修改优惠券状态
export function updateCardHidden (query) {
  return fetch({
    url: '/discountcard/hidden',
    method: 'get',
    params: query
  })
}

export function hand2UpCard (query) {
  return fetch({
    url: '/discountcard/handupdate',
    method: 'get',
    params: query
  })
}

export function pushToWechat (query) {
  return fetch({
    url: '/discountcard/uploadToWechat',
    method: 'post',
    data: query
  })
}

export function saveVipGrade (query) {
  return fetch({
    url: '/membercard/vipgrade',
    method: 'put',
    data: query
  })
}

export function listVipGrade (query) {
  return fetch({
    url: '/membercard/vipgrade',
    method: 'get',
    params: query
  })
}

export function getAllUserVipGrade(query) {
  return fetch({
    url: '/vipgrades/uselist',
    method: 'get',
    params: query
  })
}

export function receiveMemberCard(query) {
  return fetch({
    url: '/vipgrades/active_delay',
    method: 'put',
    params: query
  })
}

export function batchReceiveMemberCard(query) {
  return fetch({
    url: '/vipgrades/batch_active_delay',
    method: 'put',
    data: query
  })
}
/******优惠券分类相关**********/
export function saveCate (params) {
  return fetch({
    url: '/discountcard/creatcates',
    method: 'post',
    data: params
  })
}
export function getCateList (query) {
  return fetch({
    url: '/discountcard/cate',
    method: 'get',
    params: query
  })
}
export function updateCate (CateId, params) {
  return fetch({
    url: '/discountcard/updateCates/'+CateId,
    method: 'put',
    data: params
  })
}
export function deleteCate (CateId) {
  return fetch({
    url: '/discountcard/deleteCate/' + CateId,
    method: 'delete'
  })
}

export function setCouponDate (params) {
  return fetch({
    url: '/discountcard/offline/setCouponDate',
    method: 'post',
    data: params
  })
}

// 导入线下优惠券
export function handleUploadFileImport (params) {
  return fetch({
    url: '/discountcard/offline/import',
    method: 'post',
    data: params
  })
}
// 导入线下优惠券追加
export function handleUploadFileImportAdd (params) {
    return fetch({
        url: '/discountcard/offline/importAdd',
        method: 'post',
        data: params
    })
}
export function getOfflineList (query) {
  return fetch({
    url: '/discountcard/offline/getlist',
    method: 'get',
    params: query
  })
}

export function getOfflineListnoAuth (query) {
    return fetch({
        url: '/discountcard/offline/getlist/noAuth',
        method: 'get',
        params: query
    })
}

export function saveOffline (id,query) {
  return fetch({
    url: '/discountcard/offline/saveData/'+id,
    method: 'put',
    params: query
  })
}

export function updateOffineRel (params) {
    return fetch({
        url: '/discountcard/offline/relCardid',
        method: 'put',
        params: params
    })
}

export function getCouponQRcode(query) {
    return fetch({
        url:'discountcard/getQRcode',
        method:'get',
        params:query
    })
}

// 生成下载优惠券码
export function downLoadCardCode(query){
    return fetch({
        url: '/discountcard/downCouponCode',
        method: 'post',
        params: query
    })
}

//优惠券活动
export function getCouponActivity(query) {
    return fetch({
        url: '/discountcard/activityslist',
        method: 'get',
        params: query
    })
}

// 保存优惠券活动
export function saveCouponActivity(query) {
    return fetch({
        url: '/discountcard/saveActivity',
        method: 'post',
        params: query
    })
}

// 优惠券活动详情
export function getCouponActivityDetail(id,query) {
    return fetch({
        url: '/discountcard/activitysdetail/'+ id,
        method: 'get',
        params: query
    })
}
// 下载指定店铺优惠券活动二维码
export function downLoadCouponActivityQrcodes(query) {
    return fetch({
        url : "discountcard/activityQrcods",
        method: "post",
        params: query
    })
}

export function setRandCardRule(query) {
  return fetch({
      url : "/discountcard/setRandCardRule",
      method: "post",
      data: query
  })
}

export function getRandCard(query) {
  return fetch({
      url : "/discountcard/getRandCard",
      method: "get",
      params: query
  })
}

//订单送券获取列表
export function getOrderCardList(query) {
  return fetch({
      url : "/kaquan/ordersendcard",
      method: "get",
      params: query
  })
}


//订单送券获取详情
export function getOrderCardRow(id) {
  return fetch({
      url : "/kaquan/ordersendcard/"+id,
      method: "get",
  })
}

//订单送券保存
export function saveOrderCard(data) {
  return fetch({
      url : "/kaquan/ordersendcard",
      method: "post",
      data: data
  })
}

//订单送券编辑
export function editOrderCard(id,data) {
  return fetch({
      url : "/kaquan/ordersendcard/"+id,
      method: "put",
      data: data
  })
}

//订单送券获取详情
export function delOrderCard(id) {
  return fetch({
      url : "/kaquan/ordersendcard/"+id,
      method: "delete",
  })
}

//获取中台卡券列表，并保存到多店铺
export function syncKaquanList (query) {
  return fetch({
    url: '/discountcard/getKaquanList',
    method: 'get',
    params: query
  })
}
/**
 * 组合券包
 * @param {*} query
 * @returns
 */
export function getKaquanPackageList (query) {
  return fetch({
    url: '/discountcard/kaquanpackage',
    method: 'get',
    params: query
  })
}

/**
 * 组合券包同步
 * @param {*} query
 * @returns
 */
 export function syncKaquanPackageList (query) {
  return fetch({
    url: '/discountcard/getCanSellCardPackageList',
    method: 'get',
    params: query
  })
}

/**
 * 组合券包详情
 * @param {*} query
 * @returns
 */
 export function getKaquanPackageInfo (package_num_id) {
  return fetch({
    url: '/discountcard/kaquanpackage/'+package_num_id,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/cardticket.js